import React from 'react'
import { Route } from 'react-router-dom'
import { OpenAuth } from '../../view-open/open-auth'
import { OpenClient } from '../../view-open/open-client'
import { OpenLink } from '../../view-open/open-link'
import { OpenRegister } from '../../view-open/open-register'
import { OpenOrganization } from '../../view-open/open-organization'
import { OpenComplete } from '../../view-open/open-complete'
import { OpenError } from '../../view-open/open-error'
import { OpenSignedOut } from '../../view-open/open-signed-out'
import { OpenImpersonationEnded } from '../../view-open/open-impersonation-ended'
import { OpenSsoConsentResult, OpenSsoConsentReview } from '../../view-open/open-sso-consent'

export const RouteOpen = () => {
  return (
    <React.Fragment>
      <Route path="/open/error" component={OpenError} />
      <Route path="/open/signed-out" component={OpenSignedOut} />
      <Route path="/open/impersonation-ended" component={OpenImpersonationEnded} />
      {/* SSO consent (spec 2026-09-26): the review page the IT administrator's
          link opens, and where Microsoft's approval lands. Public: that
          person is almost never an EducationXR user. */}
      <Route path="/open/sso-consent" exact component={OpenSsoConsentResult} />
      <Route path="/open/sso-consent/:token" component={OpenSsoConsentReview} />
      <Route path="/open/register" component={OpenRegister} />
      <Route path="/open/link" component={OpenLink} />
      <Route path="/open/organization" component={OpenOrganization} />
      <Route path="/open/complete" component={OpenComplete} />
      <Route path="/open/auth" component={OpenAuth} />
      <Route path="/open/client" component={OpenClient} />
    </React.Fragment>
  )
}
